import NativeSelectWithState from '@helvetia/components/forms/NativeSelect'
import { Option } from '@helvetia/components/forms/NativeSelect/NativeSelect.types'
import { styled } from '@helvetia/components/theme'
import { rem } from 'polished'
import * as React from 'react'
import { withNamespaces, WithNamespaces } from 'react-i18next'

import { getDefaultLanguage } from '../_utils/i18next'

class LanguageSelector extends React.Component<WithNamespaces> {
  private currentLanguage: string = getDefaultLanguage()

  private options: Option[] = [
    { text: 'DE', value: 'de' },
    { text: 'FR', value: 'fr' },
    { text: 'IT', value: 'it' },
  ]

  componentDidMount() {
    this.props.i18n.changeLanguage(this.currentLanguage)
  }

  onChange = event => {
    this.currentLanguage = event.target.value.toLowerCase()
    this.props.i18n.changeLanguage(this.currentLanguage)
  }

  render() {
    return (
      <Wrapper>
        <NativeSelectWithState
          label=""
          name="lang"
          value={this.currentLanguage}
          options={this.options}
          onChange={e => this.onChange(e)}
          forceFullText
        />
      </Wrapper>
    )
  }
}

const Wrapper = styled.div`
  max-width: ${rem(65)};
`

export default withNamespaces()(LanguageSelector)
